import moment from "moment";
import { Constants } from "../constants";

export const utcStringToFormattedLocalDateString = (
  utcString: string
): string => {
  const utc = moment.utc(utcString).toDate();
  const local = moment(utc).format(Constants.DATE_TIME_FORMAT);

  return local;
};

export const apiDateFormatting = (dateString: string): string => {
  return moment(dateString).format(Constants.API_DATE_FORMAT);
};
